<template>
  <div id="InvestorPurchaseOrders" class="data-list-container">
    <vs-table pagination :max-items="itemsPerPage" search :data="purchaseOrders">
      
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between p-4">
        <div class="flex items-center">
          <vs-icon icon-pack="feather" icon="icon-shopping-cart" class="text-primary mr-2" />
          <h4 class="text-lg font-semibold">{{ $t('TotalOrders') }}: {{ purchaseOrders.length }}</h4>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="PurchaseOrderNumber"># {{ $t("OrderNumber") }}</vs-th>
        <vs-th>{{ $t("Opportunity") }}</vs-th>
        <vs-th sort-key="RequestedTokensCount">{{ $t("Tokens") }}</vs-th>
        <vs-th sort-key="NetAmount">{{ $t("NetAmount") }}</vs-th>
        <vs-th>{{ $t("Wallet") }}</vs-th>
        <vs-th>{{ $t("Status") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr v-for="(tr, indextr) in data" :key="indextr" class="cursor-pointer hover:bg-primary-light">
            
            <vs-td>
              <span class="font-bold text-primary">{{ tr.PurchaseOrderNumber }}</span>
            </vs-td>

            <vs-td>
              <div class="flex flex-col">
                <span class="font-medium">
                  {{ currentLocale === 'ar' ? tr.OpportunityNametAr : tr.OpportunityNametEn }}
                </span>
                <small class="text-grey text-xs">{{ tr.InvestorCode }}</small>
              </div>
            </vs-td>

            <vs-td>
              <vs-chip transparent color="primary">
                <vs-avatar icon-pack="feather" icon="icon-layers" />
                {{ tr.RequestedTokensCount }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <div class="flex flex-col">
                <span class="font-bold text-dark">
                  {{ tr.NetAmount.toLocaleString() }} <small>SAR</small>
                </span>
              </div>
            </vs-td>

            <vs-td>
              <div class="flex items-center">
                <feather-icon icon="WalletIcon" svgClasses="w-4 h-4 mr-2 text-warning" />
                <span class="text-sm">{{ tr.WalletCode }}</span>
              </div>
            </vs-td>

            <vs-td>
              <vs-chip :color="getStatusColor(tr.PurchaseOrderStatusId)" class="status-chip">
                {{ currentLocale === 'ar' ? tr.StatusNameAr : tr.StatusNameEn || getStatusName(tr.PurchaseOrderStatusId) }}
              </vs-chip>
            </vs-td>

          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import modulePurchaseOrders from "@/store/PurchaseOrders/modulePurchaseOrders.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";
import moduleInvestors from "@/store/Investors/moduleInvestors.js";

export default {

  props: {
    Investor: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      itemsPerPage: 10,
      keySearch: "",
      filters: {
        OpportunityId: null,
    
        InvestorId: this.Investor.Id || null, 
        PurchaseOrderStatusId: null
      },
      searchTimer: null
    };
  },
  watch: {
    keySearch() { this.debouncedSearch(); },
    filters: {
      handler() { this.debouncedSearch(); },
      deep: true
    },
 
    'Investor.Id': {
      handler(newVal) {
        if (newVal) {
          this.filters.InvestorId = newVal;
          this.applyFilters(); 
        }
      },
      immediate: true 
    }
  },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    opportunitiesOptions() { return this.$store.state.OpportunitiesList.Opportunities; },
    investorsOptions() { return this.$store.state.InvestorsList.Investors || []; }, 
    statuses() { return this.$store.state.PurchaseOrdersList.PurchaseOrderStatus; },
    purchaseOrders() { return this.$store.state.PurchaseOrdersList.PurchaseOrders; }
  },
  methods: {
    getStatusName(statusId) {
      const status = this.statuses.find(s => s.Id === statusId);
      if (status) {
        return this.currentLocale === 'ar' ? status.NameAr : status.NameEn;
      }
      return statusId;
    },
    getStatusColor(id) {
      if (id === 1) return "success"; 
      if (id === 2) return "warning"; 
      if (id === 3) return "danger";  
      return "primary";
    },
    debouncedSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.applyFilters(); }, 500);
    },
    applyFilters() {
    
      const payload = {
        OrderNumber: this.keySearch,
        ...this.filters
      };
      this.$store.dispatch("PurchaseOrdersList/fetchFilteredOrders", payload);
    }
  },
  created() {
    if (!modulePurchaseOrders.isRegistered) {
      this.$store.registerModule("PurchaseOrdersList", modulePurchaseOrders);
      modulePurchaseOrders.isRegistered = true;
    }
    if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
    if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }

  
    this.$store.dispatch("PurchaseOrdersList/fetchPurchaseOrderStatus");
    this.$store.dispatch("OpportunitiesList/fetchDataListItems");
    

    if (this.Investor.Id) {
      this.applyFilters();
    }
  }
};
</script>

<style lang="scss">
#InvestorPurchaseOrders {
  .vs-table--thead {
    th {
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      background: #f8f8f8;
    }
  }
  .status-chip {
    min-width: 100px;
    justify-content: center;
    font-weight: 600;
  }
  tr:nth-child(even) {
    background: #fafafa;
  }
}
</style>
